// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { UserRole } from '../types/common';
import { personaForRole } from '../hooks/usePersona';

/**
 * Who may approve or reject a plan from its detail page.
 *
 * Approve/Reject is an Ops Manager decision (admins can act as one). Operators
 * and executives can open a plan to read it, but are never offered the buttons:
 * the detail route is not role-gated (operators reach it from Home), and a
 * button that can only end in a 403 misleads. This is a presentation rule only —
 * the BFF still authorizes the decision itself (`hitl.site.write` on the
 * approval's site).
 *
 * It follows the user's real role, not the shell persona: a persona preview (an
 * admin viewing as Operator) changes what the lists show, not who may decide. The
 * role is mapped through `personaForRole`, so the Ops Manager group is defined in
 * one place and the review queue and this screen can't drift apart.
 */
export function canReviewPlans(role: UserRole | null | undefined): boolean {
  return personaForRole(role ?? null) === 'manager';
}
